import { shallowEqual, useSelector } from "react-redux";
import styles from "./OverviewTitleBadges.module.scss";
import StarRating from "@Components/StarRating";
import PropertyTags from "@Pages/Search/components/SearchListItem/components/PropertyTags";
import { AppState } from "@Store/index";
import wrapperHOC from "@Utils/wrapperHOC";
import { openReviews, shouldShowRatings } from "../../../ActionButtonSection/utils";

/**
 * Variant only: the property tag (Sold Out, else e.g. "Property of the Day") and the rating move
 * from the hero / button row onto the title row, next to the property name. Same components and
 * rules as today, new position.
 */
const OverviewTitleBadges = () => {
  const { data, reviewsCount } = useSelector(
    ({ propertyPageData }: AppState) => ({
      data: propertyPageData.data,
      reviewsCount: propertyPageData.inventoryReviewData?.length,
    }),
    shallowEqual,
  );
  const reviewsRating = data?.reviews_rating;
  const showRatings = shouldShowRatings(reviewsRating);

  return (
    <div className={styles.badges}>
      <PropertyTags
        inventory={data}
        className={styles.tag}
        dataTestId="propertyPage-property-soldOut-tag"
        isBookFormEnabledForInactiveProperty={false}
      />
      {showRatings && (
        <button type="button" className={styles.rating} onClick={() => openReviews(data)}>
          <StarRating
            rating={reviewsRating}
            reviewCount={reviewsCount || 0}
            testId="searchPage-inventoryCard-trustpilotPill"
          />
        </button>
      )}
    </div>
  );
};

export default wrapperHOC(OverviewTitleBadges, {
  componentName: "OverviewTitleBadges-PropertyPage",
  showForChina: false,
  showForWhiteLable: false,
  height: "32px",
});
